import React, { Component } from 'react';

import style from './MenuDesignPreview.module.scss';
import { FormattedMessage } from 'react-intl';

interface IProps {
  file: File;
  width: number;
  height: number;
  title: string;
}

class MenuDesignPreview extends Component<IProps> {
  render() {
    const { file, width, height, title } = this.props;

    return (
      <div className={style.container}>
        <div className={style.title}>
          <FormattedMessage id={title} />
        </div>
        <div
          className={style.preview}
          style={{
            backgroundImage: file ? `url(${URL.createObjectURL(file)})` : '',
            width,
            height,
          }}
        >
          <div className={style.header} />
          <div className={style.content}>
            <div className={style.contentInner} />
          </div>
        </div>
      </div>
    );
  }
}

export default MenuDesignPreview;
